import { RedoCheckbox } from "@redotech/arbiter/checkbox/redo-checkbox";
import { Flex } from "@redotech/arbiter/flex";
import { Text } from "@redotech/arbiter/text";
import type { Store } from "@redotech/redo-partners-portal-rpc/schema/shared/store";
import { PUBLIC_API_SCOPE_INFO } from "@redotech/redo-public-common/public-api-auth";
import { memo } from "react";

export type ApiScope = Store["scopes"][number];

function scopeLabel(scope: ApiScope): string {
  const info = Object.values(PUBLIC_API_SCOPE_INFO).find(
    (candidate) => candidate.scope === scope,
  );
  if (!info) {
    return scope;
  }
  return `${info.resourceLabel}: ${info.access === "read" ? "Read" : "Write"}`;
}

/**
 * Picks a subset of the scopes a store granted. Unlike the merchant app's
 * selector, it offers only those scopes rather than every one.
 */
export const ScopePicker = memo(function ScopePicker({
  granted,
  value,
  setValue,
}: {
  granted: ApiScope[];
  value: ApiScope[];
  setValue: (value: ApiScope[]) => void;
}) {
  return (
    <Flex dir="column" gap="md">
      <Text fontSize="sm" fontWeight="semibold" m="none">
        Scopes
      </Text>
      {granted.map((scope) => (
        <RedoCheckbox
          key={scope}
          label={scopeLabel(scope)}
          setValue={(checked) =>
            setValue(
              granted.filter((s) =>
                s === scope ? checked === true : value.includes(s),
              ),
            )
          }
          size="sm"
          value={value.includes(scope)}
        />
      ))}
    </Flex>
  );
});
